import SynthesisPlannerService from '@Services/SynthesisPlanner';
import { StructureFormats } from '@Pages/Hopinto/constants';
import { goToLanding, showInvalidParamsDialog } from '@Pages/Hopinto/actions';

/**
 * @ngdoc method
 * @methodOf app.hopinto:HopintoQueryFactory
 * @name resolveHopintoQuery
 * @param {Object} params
 * @param {Object} history
 * @param {function} addProjectAction
 * @description processes hopinto that uses advanced query
 */
// eslint-disable-next-line import/prefer-default-export
export const createRTProject = (params, history, addProjectAction) => {
  const { query } = params;
  const { qname } = params;
  // const uiDirectives = params.ui;

  if (!query || !query.includes('=') || (!query.includes(StructureFormats.SMILES) && !query.includes(StructureFormats.MOLFILE))) {
    goToLanding();
    return showInvalidParamsDialog();
  }
  const structureFormat = query.includes(StructureFormats.SMILES) ? StructureFormats.SMILES : StructureFormats.MOLFILE;
  const structure = query.replace(`${structureFormat}=`, '').replace(/['"]+/g, '');

  return (async () => {
    const projectParams = { name: qname };
    if (structureFormat === StructureFormats.SMILES) {
      projectParams.smilesStructure = structure;
    } else {
      projectParams.structure = structure.replace(/\\n/g, '\n');
    }
    await addProjectAction(projectParams, { location: history.location });
    SynthesisPlannerService.synthesisProjectCreateAction(history);
  })();
};
